import Instructor, { InstructorClient } from "./instructor"

export { type InstructorClient }
export * from "./types"

export default Instructor
